export default {
    addCurrencyToBonusSettings(bonus, currency) {
        if (!currency) return;
        bonus.providers.forEach(p => {
            if (!p.currencies.find(c => c.currency == currency)) p.currencies.push({ currency: currency, maxBet: 0 });
            p.games.forEach(g => {
                if (!g.currencies.find(c => c.currency == currency)) g.currencies.push({ currency: currency, maxBet: 0 });
            });
        });
    },
    removeCurrencyFromBonusSettings(bonus, currency) {
        if (!currency) return;
        bonus.providers.forEach(p => {
            let provCurIndex = p.currencies.findIndex(c => c.currency == currency);
            if (provCurIndex >= 0) p.currencies.splice(provCurIndex, 1);
            p.games.forEach(g => {
                let gameCurIndex = g.currencies.findIndex(c => c.currency == currency);
                if (gameCurIndex >= 0) g.currencies.splice(gameCurIndex, 1);
            });
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/clients/client/settings/bonuses/bonusSettings.helper.js